function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.4,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M18.998.151a.6.6 0 01.051.847l-11.52 13a.6.6 0 01-.851.047l-6.48-5.85a.6.6 0 01.804-.89l6.03 5.444L18.152.202a.6.6 0 01.847-.051z",
  fill: "currentColor"
});

function SvgMarkCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 11",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAyNCAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuNCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBkPSJNMTguOTk3OSAwLjE1MDk1MkMxOS4yNDU5IDAuMzcwNzI0IDE5LjI2ODggMC43NDk5MzIgMTkuMDQ5MSAwLjk5NzkzOUw3LjUyOTA2IDEzLjk5NzlDNy40MjI4OCAxNC4xMTc4IDcuMjczMjMgMTQuMTkwMiA3LjExMzM5IDE0LjE5OTFDNi45NTM1NSAxNC4yMDggNi43OTY3NyAxNC4xNTI2IDYuNjc3OTQgMTQuMDQ1NEwwLjE5Nzk0MyA4LjE5NTM3Qy0wLjA0ODAyMyA3Ljk3MzMyIC0wLjA2NzQwODYgNy41OTM5MSAwLjE1NDY0NCA3LjM0Nzk0QzAuMzc2Njk3IDcuMTAxOTggMC43NTYxMDEgNy4wODI1OSAxLjAwMjA3IDcuMzA0NjVMNy4wMzI1NyAxMi43NDg5TDE4LjE1MDkgMC4yMDIwNzVDMTguMzcwNyAtMC4wNDU5MzEyIDE4Ljc0OTkgLTAuMDY4ODE5OCAxOC45OTc5IDAuMTUwOTUyWiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPg==";
export { SvgMarkCheckIcon as ReactComponent };